import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid justify-content-center" }
const _hoisted_2 = { class: "navbar-nav row flex-row flex-md-column" }
const _hoisted_3 = { class: "px-md-4" }
const _hoisted_4 = { class: "px-md-4 nav-link" }

import {
    ref,
    onMounted,
    onBeforeUnmount,
    computed,
    ComputedRef,
    Ref,
  } from 'vue'

  // vueuse
  import { useElementVisibility } from '@vueuse/core'

  // Router
  import { useRoute } from 'vue-router'

  // Icons
  import ProfileIcon from '@/assets/ProfileIcon.vue'
  import ReservationIcon from '@/assets/ReservationIcon.vue'
  import BedIcon from '@/assets/BedIcon.vue'

  // Components
  import UserName from './UserName.vue'
  import Logout from './Logout.vue'

  // Config
  import { RouteConfig } from '@/config'

  // Composables
  import useScreenSize from '@/composables/useScreenSize'

  // Translations
  import { useI18n } from 'vue-i18n'
  const mobileTextClasses = 'subcaption text-primary-white'
  const desktopTextClasses = 'body text-grey-900'
  const navContentBaseClasses =
    'nav-content d-flex flex-column flex-lg-row align-items-center text-center py-md-2 px-md-3 border-radius-button-secondary'
  const iconClasses = 'mb-1 mb-lg-0 me-lg-3'
  const desktopActiveClasses = 'bg-primary-blue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

  const { t } = useI18n()

  const route = useRoute()

  // Define nav links for dynamic rendering
  const navLinks = ref([
    {
      icon: ReservationIcon,
      label: t('navbar.confirmed'),
      route: RouteConfig.CONFIRMED,
      class: 'col-3',
    },
    {
      icon: BedIcon,
      label: t('navbar.quotes'),
      route: RouteConfig.QUOTE,
      class: 'col-6 d-flex d-md-block justify-content-center',
    },
    {
      icon: ProfileIcon,
      label: t('navbar.profile'),
      route: RouteConfig.PROFILE,
      class: 'col-3',
    },
  ])

  // vueuse functionality
  const footerElem: Ref<HTMLElement | null> = ref(null)
  const isFooterInViewport: Ref<boolean> = useElementVisibility(footerElem)

  // Methods
  const isActive = (routeName: string) => {
    return route.path === `/account/${routeName}`
  }


  // Computed
  const { isMobile } = useScreenSize()

  const navContentClasses: ComputedRef<string> = computed(() => {
    return `${isMobile.value ? mobileTextClasses : desktopTextClasses} ${navContentBaseClasses}`
  })

  const activeNavClasses: ComputedRef<string> = computed(() => {
    return `${isMobile.value ? '' : desktopActiveClasses} active`
  })

  // Scroll listeners
  const setFooterElem = (): void => {
    footerElem.value = document.querySelector('.footer-register-container')
  }

  const setScrollListener = (): void => {
    // If the value has already been set, remove the listener
    if (footerElem.value) {
      removeScrollListener()
      return
    }
    window.addEventListener('scroll', setFooterElem, false)
  }

  const removeScrollListener = (): void => {
    window.removeEventListener('scroll', setFooterElem, false)
  }

  onMounted(() => {
    setFooterElem()
    setScrollListener()
  })

  onBeforeUnmount(() => {
    removeScrollListener()
  })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand", {
      'fixed-bottom bg-primary-blue': _unref(isMobile),
      'd-none': _unref(isMobile) && _unref(isFooterInViewport),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", _hoisted_3, [
                _createVNode(UserName)
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("li", { class: "px-md-4 nav-link d-none d-md-block" }, [
                _createElementVNode("div", { class: "seperator my-1" })
              ], -1))
            ], 64))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, (link) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.route,
            class: _normalizeClass(["nav-item", [link.class, { 'w-100': !_unref(isMobile) }]])
          }, [
            _createVNode(_component_router_link, {
              to: link.route,
              class: _normalizeClass(["nav-link d-block", { 'w-100': !_unref(isMobile) }])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`${navContentClasses.value} ${isActive(link.route) && activeNavClasses.value}`)
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), {
                    class: _normalizeClass(iconClasses)
                  })),
                  _createElementVNode("span", null, _toDisplayString(link.label), 1)
                ], 2)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ], 2))
        }), 128)),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[1] || (_cache[1] = _createElementVNode("li", { class: "px-md-4 nav-link" }, [
                _createElementVNode("div", { class: "seperator my-1" })
              ], -1)),
              _createElementVNode("li", _hoisted_4, [
                _createVNode(Logout)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})